import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/driverscore/',
    name: 'List Driver Score V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b4a-penilaian-pengemudi-v2:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () =>
      import(/* webpackChunkName: "score" */ '@/router/views/driverscore/driverscore-v2/index-v2'),
  },

  {
    path: '/driverscore/detaildriverscore/:driverId',
    name: 'Detail Driver Score V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b4a-penilaian-pengemudi-v2:read'])) {
          next()
        } else {
          next({ name: 'List Driver Score V2' })
        }
      },
    },
    component: () =>
      import(
        /* webpackChunkName: "score" */ '@/router/views/driverscore/driverscore-v2/DetailDriverScore-v2'
      ),
  },

  {
    path: '/driverscore/detaildriverscore/map',
    name: 'Warning Details',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b4a-penilaian-pengemudi-v2:read'])) {
          next()
        } else {
          next({ name: 'Detail Driver Score V2' })
        }
      },
    },
    component: () => import(/* webpackChunkName: "score" */ '@/router/views/driverscore/detailmap'),
  },

  // revamped Configuration
  {
    path: '/driverscore/configuration',
    name: 'List Configuration V2',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccessAll'](['b4a-penilaian-pengemudi-v2:read'])) {
          next()
        } else {
          next({ name: 'List Driver Score V2' })
        }
      },
    },
    component: () => import('@/router/views/driverscore/configuration/index-v2'),
  },
]
